import AdminMainContainer from '../../../../layouts/admin/AdminMainContainer'
import { DataGrid } from '@mui/x-data-grid'
import useAdminMedicalReimbursementsRespondedPageViewModel from './viewModel'
import { Alert, Box, Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import constants from '../../../../constants'

export default function AdminMedicalReimbursementsRespondedPage() {
  const viewModel = useAdminMedicalReimbursementsRespondedPageViewModel()

  return (
    <AdminMainContainer title='Medical Reimbursements (Responded)'>
      <Alert
        severity='info'
        action={
          <Button
            color='inherit'
            size='small'
            startIcon={<RefreshIcon />}
            onClick={() => viewModel.fetchMedicalReimbursementsRespondedData()}
          >
            Refresh
          </Button>
        }
        sx={{ mb: 2 }}
      >{`This page only showing latest ${constants.limits.fetchDataCount.md} data.`}</Alert>
      <Box sx={{ maxWidth: '100%' }}>
        <DataGrid
          showToolbar
          density='compact'
          columns={viewModel.tableData.columns}
          rows={viewModel.tableData.rows}
          loading={viewModel.dataFetchStatus.isLoading}
        />
      </Box>
    </AdminMainContainer>
  )
}
